module.exports = __webpack_public_path__ + "static/background-525d20fff75e88db452a4dce3a5961d4.png";